var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 98.681,
    height: 98.68,
    viewBox: "0 0 98.681 98.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_9763",
    x: 0,
    y: 0,
    width: 98.681,
    height: 98.68,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c9cfd7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "favourites-filled-star-symbol",
    transform: "translate(27 21.838)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27, -21.84)",
    filter: "url(#Path_9763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9763-2",
    "data-name": "Path 9763",
    d: "M42.737,18.4l-12.3-1.225A2.142,2.142,0,0,1,28.67,15.8L24.263,4.554a2.072,2.072,0,0,0-3.914,0L15.977,15.8a2.1,2.1,0,0,1-1.763,1.373L1.909,18.4a2.268,2.268,0,0,0-1.2,3.9l9.273,8.572a2.29,2.29,0,0,1,.67,2.189L7.868,45.076a2.155,2.155,0,0,0,3.138,2.45l10.26-6.346a2.042,2.042,0,0,1,2.151,0l10.26,6.346a2.148,2.148,0,0,0,3.138-2.45l-2.75-12.023a2.29,2.29,0,0,1,.67-2.189l9.273-8.572A2.3,2.3,0,0,0,42.737,18.4Z",
    transform: "translate(27 20.84)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStar);
export default __webpack_public_path__ + "static/media/noStar.85dd33f0cd794a0df9aef0c5c7bd9ee6.svg";
export { ForwardRef as ReactComponent };